import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ROUTES } from 'base/routes/routes';

import { observer } from 'mobx-react';
import * as rootStore from 'stores/root_store';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer } from 'react-toastify';
import { createLoginLayout, createDefaultLayout } from 'base/ui/layout/layout';
import { createPages } from 'pages/create';
import { Header as HeaderView } from 'base/ui/layout/header/header';
import { Sidebar as SidebarView } from 'base/ui/layout/sideBar/sideBar';
import { Footer as FooterView } from 'base/ui/layout/footer/footer';

export function createApp() {
  // const services = createServices('api-url');
  const services = rootStore.services;
  // const userPresenter = createUserPresenter(services);

  // Create global stores
  // const userStore = userPresenter.createStore();
  // const userStore = rootStore.userStore;
  // Init/load stores

  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ccc',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
              borderWidth: '1px',
            },
          },
        },
      },
    },
  });

  // khởi tạo header, sidebar, footer
  const Header = observer(() => <HeaderView />);
  const Sidebar = observer(() => <SidebarView />);
  const Footer = observer(() => <FooterView />);

  // Tạo ra 2 layout
  // Layout cho trang login chỉ có content không có sidebar, header, footer
  const layoutLogin = createLoginLayout();
  // Layout mặc định sẽ có đầy đủ sidebar, header, footer
  const layoutDefault = createDefaultLayout(Header, Sidebar, Footer);
  // khỏi tạo các trang với layout tương ứng
  const { LoginPage, DiagramMachinePage } = createPages(layoutLogin, services);
  const {
    HomePage,
    TestTargetPage,
    AddTestTargetPage,
    WorkOrderPage,
    AddSerialPage,
    WODetailPage,
    ProductPage,
    ProductDetailPage,
    MachineStatusPage,
    ProductionPlanPage,
    ProductionPlanDetailsPage,
    QnPPage,
    QnPPivoteTablePage,
    CheckStatusMarketingPage,
    StuckWarningPage,
    EditProductPage,
    ProductRoutingPage,
    MatchCardCommandPage,
    MatchCardCommandDetailPage,
    CompletionRatePage,
    MachineBreakdownTimePage,
    MachineUptimePage,
    ProductionActivitiesPage,
    ProductionTimePage,
    WorkOrderFinishedPage,
    ProductionPlanSlideDetailsPage,
    HistoryReceivePage,
    HistoryReceiveDetailPage,
    CheckSMDetailPage,
    // Nhập kho khuông
    StockReceivingPage,
    // detail nhập kho khuôn
    StockRecevingDetailPage,
    // thêm mới nhập kho khuôn
    StockReceivingAddPage,
    // Dữ liệu nền
    // Lại các danh mục dùng chung
    CatalogTypePage,
    AddCatalogPage,
    ProductionPlanningPage,

    // List Routing/Transfer
    RoutingOrTransferPage,
    AddRoutingOrTransferPage,
    UpdateRoutingOrTransferPage,


    StyleCategoryPage
  } = createPages(layoutDefault, services);

  return () => (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            {/* Trang đăng nhập */}
            <Route path={ROUTES.LOGIN.BASE} element={<LoginPage />} />
            {/* Trang chủ */}
            <Route path={ROUTES.HOME} element={<HomePage />} />
            {/* ==================== CHỈ TIÊU KIỂM TRA THEO CÔNG ĐOẠN ============================ */}
            <Route path={ROUTES.TEST_TARGET.BASE} element={<TestTargetPage />} />
            <Route path={ROUTES.TEST_TARGET.ADD_TEST_TARGET.BASE} element={<AddTestTargetPage />} />
            <Route path={ROUTES.TEST_TARGET.EDIT_TEST_TARGET.BASE} element={<AddTestTargetPage />} />
            {/* ==================== REPORT MACHINE_STATUS ============================ */}
            <Route path={ROUTES.REPORTS.MACHINE_STATUS.LINK} element={<MachineStatusPage />} />
            <Route path={ROUTES.REPORTS.MACHINE_STATUS.SUB_LINK} element={<DiagramMachinePage />} />
            <Route path={ROUTES.REPORTS.REPORT_KHSX.LINK} element={<ProductionPlanPage />} />
            <Route path={ROUTES.REPORTS.REPORT_KHSX.DETAILS_LINK} element={<ProductionPlanSlideDetailsPage />} />
            <Route path={ROUTES.REPORTS.REPORT_KHSX.BYID_LINK} element={<ProductionPlanDetailsPage />} />
            <Route path={ROUTES.REPORTS.REPORT_SLNS.LINK} element={<QnPPage />} />
            <Route path={ROUTES.REPORTS.REPORT_SLNS.SUB_LINK} element={<QnPPivoteTablePage />} />
            {/* BC11 */}
            <Route path={ROUTES.REPORTS.REPORT_MARKETING.LINK} element={<CheckStatusMarketingPage />} />
            <Route
              path={ROUTES.REPORTS.REPORT_MARKETING.REPORT_MARKETING_DETAIL.LINK}
              element={<CheckSMDetailPage />}
            />

            <Route path={ROUTES.REPORTS.REPORT_STUCKWARNING.LINK} element={<StuckWarningPage />} />
            <Route path={ROUTES.REPORTS.REPORT_TILEHTTUNGCONGDOAN.LINK} element={<CompletionRatePage />} />
            <Route path={ROUTES.REPORTS.REPORT_TGMMGAPSUCO.LINK} element={<MachineBreakdownTimePage />} />
            <Route path={ROUTES.REPORTS.REPORT_TGHDoMCSX.LINK} element={<MachineUptimePage />} />
            <Route path={ROUTES.REPORTS.REPORT_HDSXCUAMAYMOC.LINK} element={<ProductionActivitiesPage />} />
            <Route path={ROUTES.REPORTS.REPORT_TGSX.LINK} element={<ProductionTimePage />} />
            <Route path={ROUTES.REPORTS.REPORT_LSXHT.LINK} element={<WorkOrderFinishedPage />} />

            <Route path={ROUTES.WORK_ORDER.BASE} element={<WorkOrderPage />} />
            {/* ======== Màn hình chọn serial cho khuôn =============== */}
            <Route path={ROUTES.WORK_ORDER.ADD_SERIAL.BASE} element={<AddSerialPage />} />
            {/* Trang thông tin lệnh sản xuất */}
            <Route path={ROUTES.WORK_ORDER.WORK_ORDER_DETAIL.BASE} element={<WODetailPage />} />
            {/* Trang thông tin Sản phẩm */}
            <Route path={ROUTES.PRODUCT.BASE} element={<ProductPage />} />
            <Route path={ROUTES.PRODUCT.PRODUCT_DETAIL.BASE} element={<ProductDetailPage />} />
            <Route path={ROUTES.PRODUCT.EDIT_PRODUCT.BASE} element={<EditProductPage />} />
            {/* trang thông tin công đoạn sản xuất */}
            <Route path={ROUTES.PRODUCT_ROUTING.BASE} element={<ProductRoutingPage />} />
            {/* trang thông tin lệnh ghép bài */}
            <Route path={ROUTES.MATCH_CARD_COMMAND.BASE} element={<MatchCardCommandPage />} />
            <Route
              path={ROUTES.MATCH_CARD_COMMAND.MATCH_CARD_COMMAND_DETAIL.BASE}
              element={<MatchCardCommandDetailPage />}
            />

            {/* Báo cáo kế hoạch sản xuất  */}
            <Route path={ROUTES.WORK_ORDER.REPORT_PRODUCTION_PLANNING.BASE} element={<ProductionPlanningPage />} />
            {/* ====== Lịch sử nhập kho =========================== */}
            <Route path={ROUTES.HISTORY_RECEIVE.BASE} element={<HistoryReceivePage />} />
            {/* Màn hình chỉnh sửa */}
            <Route path={ROUTES.HISTORY_RECEIVE.HISTORY_RECEIVE_DETAIL.BASE} element={<HistoryReceiveDetailPage />} />
            {/* =================================================== */}
            {/* ====== Nhập kho khuôn =========================== */}
            <Route path={ROUTES.STOCKRECEIVING.BASE} element={<StockReceivingPage />} />
            {/* Man hình detail */}
            <Route path={ROUTES.STOCKRECEIVING.STOCKRECEIVING_DETAIL.BASE} element={<StockRecevingDetailPage />} />
            {/* Màn hình thêm mới */}
            <Route path={ROUTES.STOCKRECEIVING.ADD_STOCKRECEIVING.BASE} element={<StockReceivingAddPage />} />
            {/* =================================================== */}
            {/* ================ Dữ liệu nền */}
            <Route path={ROUTES.MASTER_DATA.CATALOG.LINK} element={<CatalogTypePage />} />
            {/* Add Catalog */}
            <Route path={ROUTES.MASTER_DATA.CATALOG.CREATE} element={<AddCatalogPage />} />
            {/* Routing page - Add & Edit */}
            <Route path={ROUTES.MASTER_DATA.ROUTING_TRANSFER.LINK} element={<RoutingOrTransferPage />} />
            <Route path={ROUTES.MASTER_DATA.ROUTING_TRANSFER.CREATE} element={<AddRoutingOrTransferPage />} />
            <Route path={ROUTES.MASTER_DATA.ROUTING_TRANSFER.EDIT} element={<UpdateRoutingOrTransferPage />} />


            {/* kiểu dáng sản phẩm */}
            <Route path={ROUTES.STYLE_CATEGORY.BASE} element={<StyleCategoryPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
      {/* React toastify // hiển thị thông báo */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
